import { render, staticRenderFns } from "./LiveCallsCount.vue?vue&type=template&id=2aaaffd8&scoped=true"
import script from "./LiveCallsCount.vue?vue&type=script&lang=js"
export * from "./LiveCallsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaaffd8",
  null
  
)

export default component.exports